var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.redirectHome)?_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",style:(`height: ${_vm.height}`),attrs:{"src":require("../assets/logo-buybox.png"),"alt":"BUY.BOX"}})]):_c('img',{staticClass:"logo",style:(`height: ${_vm.height}`),attrs:{"src":require("../assets/logo-buybox.png"),"alt":"BUY.BOX"}})
}
var staticRenderFns = []

export { render, staticRenderFns }